module.exports = __webpack_public_path__ + "images/307b051bcb06b7eda7559c8bcb2171c9.gif";